<template>
    <div class="about-us">
        <menuBox :step="5"></menuBox>
        <div class="about-title">聯繫我們</div>
        <div class="us-list">
            <div class="us">
                <img src="../assets/about-2.png" alt="">
                <div class="name">電話</div>
                <div class="text">00852-39622878</div>
            </div>
            <div class="us">
                <img src="../assets/about-3.png" alt="">
                <div class="name">郵箱</div>
                <div class="text">13724166@qq.com</div>
            </div>
            <div class="us">
                <img src="../assets/about-4.png" alt="">
                <div class="name">地址</div>
                <div class="text">UNIT 08, 15/F WITTY COMMERCIAL BUILDING 1A-1L TUNG CHOI STREET, KOWLOON HONG KONG</div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.about-us {
    .about-title {
        background-image: url(../assets/about-1.png);
        width: 100%;
        height: 320px;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 48px;
        font-weight: 500;
        color: #333333;
    }

    .us-list {
        padding: 72px 340px 96px 340px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .us {
            width: 320px;
            height: 236px;
            background: #FFFFFF;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
            border-radius: 8px;
            border: 1px solid #EBEBEB;
            padding: 30px 40px;
            display: flex;
            align-items: center;
            flex-direction: column;
            align-content: center;

            img {
                width: 72px;
                height: 72px;
            }

            .name {
                font-size: 20px;
                margin-top: 16px;
                font-weight: 600;
                color: #333333;
            }

            .text {
                font-size: 20px;
                margin-top: 16px;
                font-weight: 400;
                color: #333333;
            }
        }
    }
}</style>
